const CONST = {
  BASE_URL: `${process.env.REACT_APP_BASE_URL}/api/v1`,
  BASE_KEY: process.env.REACT_APP_BASE_KEY,
};

export default CONST;
